__turbopack_context__.v({
  "cancelButton": "styles-module-scss-module__6O-KHa__cancelButton",
  "closeButton": "styles-module-scss-module__6O-KHa__closeButton",
  "deleteButtonModal": "styles-module-scss-module__6O-KHa__deleteButtonModal",
  "error": "styles-module-scss-module__6O-KHa__error",
  "modal": "styles-module-scss-module__6O-KHa__modal",
  "modalActions": "styles-module-scss-module__6O-KHa__modalActions",
  "modalContent": "styles-module-scss-module__6O-KHa__modalContent",
  "modalDescription": "styles-module-scss-module__6O-KHa__modalDescription",
  "modalTitle": "styles-module-scss-module__6O-KHa__modalTitle",
  "portal": "styles-module-scss-module__6O-KHa__portal",
});
